<script setup>
  import { onMounted, ref, defineAsyncComponent } from "vue";
  import { getCurrencies } from '@/services/api'
  import { settings } from "@/appType/settings.js";

  const BaseSelect = defineAsyncComponent(() =>
      import(/* webpackChunkName: "BaseSelect" */ '@/components/base/selects/BaseSelect.vue')
  )

  const props = defineProps({

  })

  const currencies = ref([])

  const fetchCurrencies = async () => {
    currencies.value = await getCurrencies()

    const envName = settings.env.VUE_APP_ENV_NAME
    if (envName === 'grok' ) {
      currencies.value = currencies.value.filter(({ value }) => value !== 'RUB')
    }
  }

  const localModel = defineModel()

  onMounted(() => { // <-- Оборачиваем вызов fetchCurrencies в onMounted
    fetchCurrencies();
  })

</script>

<template>
  <div>
    <BaseSelect
        v-model="localModel"
        :label="text('create_card_page.selects.selected_currency')"
        :placeholder="text('create_card_page.selects.choose_currency')"
        :options="currencies"
        v-bind="$attrs"
    >
      <template #select-value="data">
        <div class="currency-item">
          {{ data.value }} <span class="symbol">{{ data.symbol }}</span>
        </div>
      </template>
      <template #select-option-value="data">
        <div class="currency-item">
          {{ data.value }} <span class="symbol">{{ data.symbol }}</span>
        </div>
      </template>
    </BaseSelect>
  </div>

</template>

<style scoped>
  .currency-item {
    display: flex;
    align-items: center;
    gap: 6px;

    .symbol {
      color: var(--text-color-secondary);
    }
  }
</style>